import { Text, Flex, type ColorProps, AspectRatio, type TextProps } from "@chakra-ui/react";
import React, { type ReactNode } from "react";
import NextImage from "next/legacy/image";
import { type StaticImageData } from "next/image";

type FeatureProps = {
  image?: string | StaticImageData;
  leadInText?: string;
  title: string;
  titleProps?: TextProps;
  description?: ReactNode;
  descriptionSize?: "md" | "lg" | "xl";
  color?: ColorProps["color"];
  center?: boolean; // eslint-disable-line react/boolean-prop-naming
  imageWidth?: string;
};

export function Feature({
  center,
  image,
  leadInText,
  title,
  titleProps,
  description,
  descriptionSize = "md",
  color,
  imageWidth,
}: FeatureProps) {
  return (
    <Flex
      direction="column"
      h="100%"
      w="100%"
      align={{ base: "center", md: center ? "center" : "start" }}
      textAlign={{ base: "center", md: center ? "center" : "left" }}
    >
      {leadInText && (
        <Text fontSize="md" textStyle="uppercase" color={color} mb={8}>
          {leadInText}
        </Text>
      )}
      {image && (
        <AspectRatio ratio={1 / 1} w={imageWidth ?? "120px"} mb={7}>
          <NextImage src={image} alt={`${title}.`} layout="fill" objectFit="contain" />
        </AspectRatio>
      )}

      <Text textStyle="h7" as="h3" color={color} whiteSpace="pre-wrap" {...titleProps}>
        {title}
      </Text>

      {description && (
        <Text
          mt={5}
          fontSize={descriptionSize}
          flexGrow={1}
          minHeight={0}
          color={color}
          maxW="32ch"
          whiteSpace="pre-wrap"
        >
          {description}
        </Text>
      )}
    </Flex>
  );
}
